import { useState, useEffect } from "react";
import AdminImg from "../../../assets/admin.png";
import EditYourProfile from "../../../components/EditYourProfile";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useProfile } from "../../../context/ProfileContext";
import { useMemo } from "react";
import Experience from "./show-profile/Experience";
import Subjects from "./show-profile/Subjects";
import Languages from "./show-profile/Languages";
import Skills from "./show-profile/Skills";
import Portfolio from "./show-profile/Portfolio";
import VideoIntro from "./show-profile/VideoIntro";
import Socials from "./show-profile/Socials";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("access_token");
const TeacherProfile = () => {
  // const { teacher,} = useCurrentTeacher();
 
 const {
    profileId: contextId,
  } = useProfile();
  const { setProfileId } = useProfile();
  const { userId: id } = useParams();
   const [selectedTab, setSelectedTab] = useState("Experience");
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editMode, setEditMode] = useState("fullProfile");
  const [profile, setProfile] = useState(null);
  const [apiError, setApiError] = useState("");
  const [isFollowing, setIsFollowing] = useState(false);
  const profileId = id || contextId;
  const isYourOwnProfile = useMemo(() => {
    if (profileId == null || contextId == null) return false;
    return Number(profileId) === Number(contextId);
  }, [profileId, contextId])
  
  const handleCoverUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("cover_image", file);
    try {
      await axios.post(
        `${BASE_URL}/user/profile/profile-cover-image/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      toast.success("Cover image updated!");
      fetchProfile();
    } catch (error) {
      toast.error("Failed to upload cover image.");
      console.error("Cover image upload error:", error);
    }
  };
  const fetchProfile = async () => {
    // if (!profileId) {
    //   console.warn("Profile ID not ready yet");
    //   return;
    // }

    setApiError("");
    try {
      let url;
      console.log("isYourOwnProfile: ", isYourOwnProfile);

      if (!id) {
        url = `${BASE_URL}/user/profile/create-profile`;
      } else {
        const fetchId = id || contextId;
        if (!fetchId) throw new Error("No ID found for profile");
        url = `${BASE_URL}/user/profile/all-profiles?id=${fetchId}`;
      }

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const data = await res.json();
      if (!res.ok)
        throw new Error(
          data.message || data.error || "Failed to fetch profile"
        );

      setProfile(data.data);
    } catch (error) {
      setApiError(error.message);
    } finally {
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [profileId]);

  const fetchFollowStatus = async () => {
    if (!id) return;

    try {
      const res = await fetch(`${BASE_URL}/user/follow-unfollow/follow/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });

      if (!res.ok) throw new Error("Failed to fetch follow status");
      const data = await res.json();

      const followed = data.results.some(
        (item) => item.follow_user_profile?.id === Number(id)
      );
      setIsFollowing(followed);
    } catch (error) {
      console.error("Error fetching follow status:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFollowStatus();
    }
  }, [id]);
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setProfileId(data.data?.id);
        } else {
          console.error("Profile fetch failed");
        }
      } catch (error) {
        console.error("Error fetching profile:", error.message);
      }
    };

    fetchProfile();
  }, []);
  const toggleFollow = async () => {
    if (!id) return;

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_X_API_KEY
    };

    try {
      if (isFollowing) {
        const res = await axios.delete(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          { headers, data: { id } }
        );
        if (
          res.status === 204 ||
          res.data?.message === "Successfully unfollowed."
        ) {
          setIsFollowing(false);
          toast.success("unfollowed successfully");
        }
      } else {
        const res = await axios.post(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          { id },
          { headers }
        );
        if (res.data?.message === "Successfully followed") {
          setIsFollowing(true);
          toast.success("Followed successfully");
        }
      }
    } catch (err) {
      console.error("Follow/Unfollow error:", err);
    }
  };


  return (
    <>
   <div className="relative max-w-full">
  <div style={{
    backgroundImage: "url('../../../assets/backgroundvector.jpg')",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  }}>
    {apiError ? (
      <p className="text-red-500 text-center py-4">{apiError}</p>
    ) : profile ? (
      <>
        <div className="w-full max-w-6xl py-5 pb-0 mx-auto mt-0 flex flex-col relative">
          {/* Cover Photo */}
          <div className="w-full h-[250px] mb-[-105px] rounded-xl overflow-hidden relative">
            {!id && (
              <div className="absolute top-4 right-4">
                <label 
                  htmlFor="cover-upload" 
                  className="w-12 h-12 bg-white/80 backdrop-blur-sm rounded-xl flex justify-center items-center cursor-pointer hover:bg-white hover:shadow-md transition-all border border-white/50"
                >
                  <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                </label>
                <input
                  type="file"
                  id="cover-upload"
                  className="hidden"
                  accept="image/*"
                  onChange={handleCoverUpload}
                />
              </div>
            )}
            <img
              src={profile.cover_image || AdminImg}
              alt="User profile"
              className="w-full h-full  object-cover object-center"
            />
          </div>
          
          <div className="w-full max-w-6xl py-5 pb-0 mx-auto mt-0 flex flex-col relative">
            {/* Profile Picture */}
           

            {/* Profile Info */}
            <div className="flex flex-col pl-7 w-full">
              {isEditOpen && isYourOwnProfile && (
                <>
                  <div className="fixed inset-0 bg-black/50 z-[1000]"></div>
                  <div className="fixed inset-0 z-[1010] flex items-center justify-center p-4">
                    <div className="bg-white w-full max-w-2xl max-h-[90vh] overflow-auto rounded-xl py-4">
                      <EditYourProfile
                        onClose={() => { setIsEditOpen(false); fetchProfile(); }}
                        mode={editMode}
                      />
                    </div>
                  </div>
                </>
              )}

              <div >
                <div className="flex items-center justify-between w-full mb-4">
                  <div className="flex gap-6">
                     <div className="flex relative pl-6 w-full max-w-fit mb-[10px]">
              <div className="relative">
                {profile?.profile_picture ? (
                  <img
                    src={profile.profile_picture}
                    alt="User profile"
                    className="w-[130px] h-[130px] rounded-full object-cover border-4 border-white shadow-lg"
                  />
                ) : (
                  <div className="w-[130px] h-[130px] rounded-2xl bg-[#e8f0f7] border-4 border-white shadow-lg flex items-center justify-center">
                    <svg className="w-12 h-12 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                )}
                <div className="absolute -bottom-[-10px] -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
            </div>
             <h2 className="mt-24 text-xl font-semibold text-gray-900">{profile.name}</h2>
                  </div>
                 
                  <div className="flex items-center gap-3">
                    {!id && (
                      <button
                        className="w-10 h-10 flex items-center justify-center bg-white border border-gray-300 text-gray-700 rounded-xl hover:border-[#0f6abf] hover:text-[#0f6abf] transition-all"
                        onClick={() => {
                          setEditMode("fullProfile");
                          setIsEditOpen(true);
                        }}
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    )}
                    {id && (
                      <button
                        className={`px-5 py-2 text-sm font-medium rounded-xl transition-colors ${
                          isFollowing
                            ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                            : "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
                        }`}
                        onClick={toggleFollow}
                      >
                        {isFollowing ? "Unfollow" : "Follow"}
                      </button>
                    )}
                  </div>
                </div>
                
                {profile.research_areas && (
                  <div className="flex flex-wrap gap-2 mb-6">
                    {profile.research_areas.split(',').slice(0, 3).map((area, index) => (
                      <span
                        key={index}
                        className="text-xs px-3 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg font-medium"
                      >
                        {area.trim()}
                      </span>
                    ))}
                  </div>
                )}

                {/* Profile Details Card */}
                <div className="w-full mt-6">
                  <div className="bg-[#e8f0f7] rounded-2xl p-6 space-y-4">
                    {profile.degree && (
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                        <p className="text-base font-semibold text-[#0f6abf]">{profile.degree}</p>
                      </div>
                    )}
                    
                    {profile.primary_affiliation && (
                      <div className="flex items-center gap-2">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        <p className="text-sm text-gray-700">{profile.primary_affiliation}</p>
                      </div>
                    )}
                    
                    {profile.current_activity && (
                      <div className="flex items-center gap-2">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-sm text-gray-700">{profile.current_activity}</p>
                      </div>
                    )}
                    
                    {profile.bio && (
                      <div className="pt-4 mt-4 border-t border-gray-300">
                        <div className="flex items-center gap-2 mb-3">
                          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                          <h4 className="text-sm font-semibold text-gray-900">About</h4>
                        </div>
                        <p className="text-sm text-gray-700 leading-relaxed">{profile.bio}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Teacher Info Section */}
                <div className="mt-8">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                      </svg>
                    </div>
                    <div>
                      <h1 className="text-lg font-semibold text-gray-900">Your Teacher Info</h1>
                      <p className="text-sm text-gray-500">Your teacher information is displayed here. You can manage and update your profile whenever necessary.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ) : null}
    
    {/* Tabs Navigation */}
    {profile && (
      <div className="w-full max-w-6xl p-4 mx-auto bg-white flex flex-col gap-4 rounded-b-2xl">
        <div className="flex gap-2 overflow-x-auto">
          {[
            { id: "Experience", label: "Experience" },
            { id: "Subjects", label: "Subjects" },
            { id: "Languages", label: "Languages" },
            { id: "Skills", label: "Skills" },
            { id: "Socials", label: "Socials" },
            { id: "Portfolio", label: "Portfolio" },
            { id: "VideoIntro", label: "Video Intro" }
          ].map((tab) => (
            <button
              key={tab.id}
              className={`flex-shrink-0 px-4 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
                selectedTab === tab.id
                  ? "bg-[#0f6abf] text-white shadow-sm"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              }`}
              onClick={() => setSelectedTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    )}
  </div>

  {/* Tab Content */}
  <div className="bg-gray-50 min-h-[70vh]">
    {profile && (
      <div className="w-full max-w-6xl mx-auto py-8 px-3 md:px-4">
        <div className="w-full max-w-6xl mx-auto">
          {selectedTab === "Experience" && <Experience />}
          {selectedTab === "Subjects" && <Subjects />}
          {selectedTab === "Languages" && <Languages />}
          {selectedTab === "Skills" && profileId && <Skills />}
          {selectedTab === "Socials" && profileId && <Socials />}
          {selectedTab === "Portfolio" && <Portfolio />}
          {selectedTab === "VideoIntro" && profileId && <VideoIntro />}
        </div>
      </div>
    )}
  </div>
</div>
    </>
  );
};

export default TeacherProfile;
